import React from 'react'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import DialogActions from '@mui/material/DialogActions'
import MemberPregnancyFormFields from './MemberPregnancyFormFields'
import { Form } from 'react-final-form'
import { EjentaForm } from '../../elements/EjentaForm'
import { Alert } from '@mui/material'
import { getProfileMemberFields, validateMemberForm } from '../../../utils/member/baseProfileUtils'
import { type IFormValues } from '../../../interfaces/forms.interface'

interface IMemberPregnancyFormProps {
  isNewMember?: boolean
  onCancel: () => void
  onSubmit: (formData: any) => Promise<any>
  getInitialValues: () => IFormValues
}

export default function MemberPregnancyForm (props: IMemberPregnancyFormProps): JSX.Element {
  const handleCancel = (e: any): void => {
    e.preventDefault()
    e.stopPropagation()
    props.onCancel()
  }

  const renderSubmit = ({ pristine, submitting, hasValidationErrors }): JSX.Element => {
    const submitButtonText = props.isNewMember ? 'Add member' : 'Save changes'
    let submitButton = <Button variant='contained' type='submit' data-testid='member-profile__add-member-button' disabled={pristine || hasValidationErrors}>{submitButtonText}</Button>
    if (submitting) submitButton = <Button variant='contained' disabled>Updating...</Button>

    return (
      <DialogActions data-testid='add-member__buttons'>
        {submitButton} <Button variant='outlined' onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    )
  }

  const renderMemberPregnancyForm = (): JSX.Element => {
    return (
      <Form
        onSubmit={props.onSubmit}
        initialValues={props.getInitialValues()}
        validate={values => validateMemberForm(values, getProfileMemberFields(), false)}
      >
        {({ handleSubmit, pristine, submitting, submitError, hasValidationErrors }) => (
          <EjentaForm onSubmit={handleSubmit}>
            {submitError && <Alert severity='error'>{submitError}</Alert>}

            <Box sx={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'column' }}>
              <MemberPregnancyFormFields />

              {renderSubmit({ pristine, submitting, hasValidationErrors })}
            </Box>
          </EjentaForm>
        )}
      </Form>
    )
  }

  return renderMemberPregnancyForm()
}
